export const FETCH_ACCOUNT = 'fetch/account'
